import JobConfiguration from '@/models/JobConfiguration/JobConfiguration';

export default class JobConfigurationFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.interfaceName = '';
		this.jobName = '';
		this.jobDescriptionMultiple = '';
		this.isStoredProcedure = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			interfaceName : '0',
			jobName : '0',
			jobDescriptionMultiple : '0',
			isStoredProcedure : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}